// FbGetProduct.jsx
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from './firebase';
import ProductCard from '../../FrontEnd/Integration/ProductCard';
import Spinner from '../../FrontEnd/Integration/Spinner';

export default function FbGetProduct({ pageSize = 30, currentPage = 1, onTotalChange = () => {} }) {
  const [produtos, setProdutos] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Evita erros com URLs curtas
    if (location.pathname.length <= 10) return;

    const parts = location.pathname.split('/');
    // Ex.: /Db/{col}/{subcol}/categoria/{nomeCategoria}
    // Ajuste conforme sua rota real
    const hasCategoryInPath = parts.length > 4;
    const category = hasCategoryInPath ? decodeURIComponent(parts[4]) : null;
    const route =decodeURIComponent(parts[2]);
     const sobroute =decodeURIComponent(parts[3]);

    if (parts.length < 4) return navigate('/Home');
    console.log(route, parts[3])
    const path = `Db/${route}/${sobroute}`;
    const isCategoria = parts.length === 4;

    async function fetchData() {
      setLoading(true);

      const baseQuery = isCategoria
        ? query(collection(db, path))
        : query(collection(db, path), where('category', '==', category));

      const snap = await getDocs(baseQuery);

      if (snap.empty) {
        navigate('/Home');
        return;
      }

      const items = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

      setProdutos(items);
      onTotalChange(items.length); // **IMPORTANTE**: use o array local, não o estado assíncrono
      setLoading(false);
    }

    fetchData();
  }, [location.pathname, navigate, onTotalChange]);

  // Cálculo do slice da página atual
  const start = (currentPage - 1) * pageSize;
  const end = start + pageSize;

  const pageItems = useMemo(() => {
    return produtos.slice(start, end);
  }, [produtos, start, end]);

  return (
    <>
      {loading && <Spinner />}
      <section className="produto-grid">
        {pageItems.map((prod) => (
          <ProductCard key={prod.id} {...prod} />
        ))}
      </section>
    </>
  );
}